<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="password-form-wrapper" [ngStyle]="{'min-height': showBestPractices && !showCurrentPassword ? '450px' : '415px'}">
    <form [formGroup]="passwordForm">
      <div [ngClass]="{'center': mode === 'RESET'}">
        <div class="password-rules">
          <p>{{tlMustHave1}}</p>
          <ul>
            <li>
              <span *ngIf="!p.password.errors"><span class="mdi mdi-check-bold success"></span></span>
              <span *ngIf="p.password.errors && !(p.password.errors.required || p.password.errors.minByteLength || p.password.errors.maxByteLength)"><span class="mdi mdi-check-bold success"></span></span>
              <span *ngIf="p.password.errors && (p.password.errors.required || p.password.errors.minByteLength || p.password.errors.maxByteLength)"><span class="mdi mdi-check-bold not-validated"></span></span>
              <strong>10</strong> {{tlMustHave2}} <strong>50</strong> {{tlMustHave3}}
            </li>
          </ul>
          <ul>
            <li>
            <span *ngIf="categoriesSatisfied >= 3"><span class="mdi mdi-check-bold success"></span></span>
            <span *ngIf="categoriesSatisfied < 3"><span class="mdi mdi-check-bold not-validated"></span></span>
            {{tlMustHave4}}
            </li>
            <p>

            </p>
            <li>
              <span *ngIf="hasUpperCase"><span class="mdi mdi-check-bold success"></span></span>
              <span *ngIf="!hasUpperCase"><span class="mdi mdi-check-bold not-validated"></span></span>
              <strong>{{tlUppercase}}</strong> {{tlLetter}}
            </li>
            <li>
              <span *ngIf="hasLowerCase"><span class="mdi mdi-check-bold success"></span></span>
              <span *ngIf="!hasLowerCase"><span class="mdi mdi-check-bold not-validated"></span></span>
              <strong>{{tlLowercase}}</strong> {{tlLetter}}
            </li>
            <li>
              <span *ngIf="hasUnicode"><span class="mdi mdi-check-bold success"></span></span>
              <span *ngIf="!hasUnicode"><span class="mdi mdi-check-bold not-validated"></span></span>
              <strong>{{tlUnicode}} </strong> {{tlUnicode2}}
            </li>
            <li>
              <span *ngIf="hasNumber"><span class="mdi mdi-check-bold success"></span></span>
              <span *ngIf="!hasNumber"><span class="mdi mdi-check-bold not-validated"></span></span>
              <strong>{{tlNumber}}</strong>
            </li>
            <li>
              <span *ngIf="hasSpecial"><span class="mdi mdi-check-bold success"></span></span>
              <span *ngIf="!hasSpecial"><span class="mdi mdi-check-bold not-validated"></span></span>
              <strong>{{tlSpecialCharacter}}</strong>
            </li>
          </ul>
          <div *ngIf="showCurrentPassword">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{tlCurrentPassword}}</mat-label>
              <span style="display: flex;">
                <input
                  [type]="showCurrentPass ? 'text' : 'password'"
                  matInput
                  formControlName="currentPassword"
                  id="currentPassInput"
                  (capsLock)="onCapsLockCurrentChanged($event)"
                  (focus)="passwordFocus($event.target?.id)"
                  (blur)="passwordBlur()"
                  (input)="tooltipCurrent?.show()"
                />
                @if (capsOnCurrent) {
                  <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon" #tooltipCurrent="matTooltip"
                          matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}" matTooltipPosition="right">
                  </mat-icon>
                }
              </span>
              <mat-error *ngIf="submittedPasswd && p.currentPassword.errors && p.currentPassword.errors.required">{{tlCurrentIsReq}}</mat-error>
            </mat-form-field>
            <span (click)="showCurrentPass = !showCurrentPass">
              <span *ngIf="showCurrentPass"><span class="mdi mdi-eye show-hide-pass"></span></span>
              <span *ngIf="!showCurrentPass"><span class="mdi mdi-eye-off show-hide-pass"></span></span>
            </span>
          </div>

          <div>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{tlNewPassword}}</mat-label>
              <span style="display: flex;">
                <input
                  [type]="showNewPass ? 'text' : 'password'"
                  matInput
                  formControlName="password"
                  id="newPassInput"
                  (capsLock)="onCapsLockNewChanged($event)"
                  (focus)="passwordFocus($event.target?.id)"
                  (blur)="passwordBlur()"
                  (input)="tooltipNew?.show()"
                />
                @if (capsOnNew) {
                  <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon"
                          #tooltipNew="matTooltip"
                          matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}" matTooltipPosition="right">
                  </mat-icon>
                }
              </span>
              <mat-error id="passErrorRequired" *ngIf="p.password.errors && p.password.errors.required" class="error-message">{{tlPwdRequired}}</mat-error>
              <mat-error id="passErrorNeedsMoreCategories" *ngIf="p.password.errors && showPasswordError('needsMoreCategories')" class="error-message">{{tlErrorCategories}}</mat-error>
              <mat-error id="passErrorHasMinMaxlength" *ngIf="p.password.errors && showPasswordError('hasMinMaxlength')" class="error-message">{{tlErrorLen}}</mat-error>
              <mat-error id="passErrorTooSimilar" *ngIf="p.password.errors && p.password.errors.tooSimilar" class="error-message">{{tlErrorSimCurrent}}</mat-error>
              <mat-error id="passErrorEmailOrSimilar" *ngIf="p.password.errors && p.password.errors.emailOrSimilar" class="error-message">{{tlErrorSimEmail}}</mat-error>
              <mat-error id="passErrorContainsPipeSymbol" *ngIf="p.password.errors && p.password.errors.containsPipeSymbol" class="error-message">{{tlErrorContainsPipe}}</mat-error>
            </mat-form-field>
            <span (click)="showNewPass = !showNewPass">
              <span *ngIf="showNewPass"><span class="mdi mdi-eye show-hide-pass"></span></span>
              <span *ngIf="!showNewPass"><span class="mdi mdi-eye-off show-hide-pass"></span></span>
            </span>
          </div>

          <div>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{tlConfirmNewPwd}}</mat-label>
              <span style="display: flex;">
                <input
                  [type]="showNewPass ? 'text' : 'password'"
                  matInput
                  formControlName="confirmPassword"
                  id="confirmPassInput"
                  (capsLock)="onCapsLockConfirmChanged($event)"
                  (focus)="passwordFocus($event.target?.id)"
                  (blur)="passwordBlur()"
                  (input)="tooltipConfirm?.show()"
                />
                @if (capsOnConfirm) {
                  <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon"
                            #tooltipConfirm="matTooltip" matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}"
                            matTooltipPosition="right">
                  </mat-icon>
                }
              </span>
              <mat-error *ngIf="p.confirmPassword.errors && p.confirmPassword.errors.required" class="invalid-feedback">{{tlConfirmReq}}</mat-error>
              <mat-error *ngIf="p.confirmPassword.errors && p.confirmPassword.errors.mustMatch" class="invalid-feedback">{{tlErrorConfirmMustMatch}}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
    <div *ngIf="showBestPractices" class="best-practices">
      <p><strong>{{tlBestPractices}}</strong></p>
      <p><strong>{{tlUse}}:</strong></p>
      <ul>
        <li>{{tlUsePasswordMgr}}</li>
        <li>{{tlUseUniquePwd}}</li>
        <li>{{tlUseCase}}
          <br><strong>( </strong>
          <span *ngFor="let char of getSpecialChars()">{{char}} </span>
          <strong>)</strong>
        </li>
        <li>{{tlUseLongLen}}</li>
      </ul>
      <p><strong>{{tlDoNotUse}}:</strong></p>
      <ul>
        <li>{{tlDoNotRepeat}}</li>
        <li>{{tlDoNotUseUsernameEmail}}</li>
        <li>{{tlDoNotUsePersonal}}</li>
      </ul>
      <p><strong>{{tlAvoid}}:</strong></p>
      <ul>
        <li>{{tlAvoidWriting}}</li>
        <li>{{tlAvoidSharing}}</li>
        <li>{{tlAVoidSaving}}</li>
      </ul>
    </div>
    <span [ngSwitch]="mode">
      <!-- <div *ngSwitchCase="'UPDATE'" class="button-wrapper"> -->
      <div *ngSwitchCase="'UPDATE'">
        <button mat-raised-button color="primary" id="updatePassBtn" (click)="onUpdatePassword()">Submit</button>
      </div>
      <div *ngSwitchCase="'RESET'" class="reset-btn-wrapper">
        <button class="reset-btn" (click)="onResetPassword()" mat-flat-button>Reset</button>
      </div>
      <div *ngSwitchCase="'INVITATION'" class="reset-btn-wrapper">
        <button class="reset-btn" (click)="onResetPasswordByInvitation()" mat-flat-button>Submit</button>
      </div>
      <div *ngSwitchCase="'DEVICE_UPDATE'" class="reset-btn-wrapper">
        <button id = "submitButton" class="reset-btn" (click)="onUpdatePasswordForDeviceLogin()" mat-flat-button>Submit</button>
      </div>
    </span>
  </div>
